
import { ref, nextTick, provide } from "vue";
import { useStore } from "vuex";
import "./asstes/style.css";
export default {
  name: "育网-云盘",
  setup() {
    // 局部组件刷新
    let store = useStore();
    const isRouterAlive = ref(true);
    const reload = () => {
      isRouterAlive.value = false;
      nextTick(() => {
        isRouterAlive.value = true;
      });
    };
    provide("reload", reload);
      window.onresize = () => {
        return (() => {
          const html = document.querySelector("html");
          if (html != null) {
            html.style.fontSize = window.innerWidth / 192 + "px";
          }
        })();
      };
      window.onload = () => {
        return (() => {
          store.commit("dqmulu");
          const html = document.querySelector("html");
          if (html != null) {
            html.style.fontSize = window.innerWidth / 192 + "px";
          }
        })();
      };
    
    return {
      isRouterAlive,
    };
  },
};
document.addEventListener("DOMContentLoaded", () => {
  const html = document.querySelector("html");
  if (html != null) {
    html.style.fontSize = window.innerWidth / 192 + "px";
  }
});
window.addEventListener('resize', () => { //监听浏览器窗口大小改变
  const html = document.querySelector("html");
  if (html != null) {
    html.style.fontSize = window.innerWidth / 192 + "px";
  }
});
